export const ERROR_CODES = {
  PHONE_CODE_INVALID: 'Invalid Code'
}
